<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card border-variant="primary">
          <b-card-body class="pb-0">
            <b-table responsive="sm" :items="projects" :fields="captions" fixed :current-page="currentPage" :per-page="perPage">
              <template slot="actions" slot-scope="data">
                <b-button variant="primary" size="sm" class="mr-1" :href="'/api/media/links/' + data.item.filename" target="_blank">
                  Show
                </b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>        
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Projects',
  data () {
    return {
      currentPage: 1,
      perPage: 25,
      projects: [],
      captions: [
        { key: 'id', sortable: true },
        { key: 'name', sortable: true },
        { key: 'date', sortable: true },
        { key: 'createdAt', sortable: true },
        { key: 'count', sortable: true },
        { key: 'actions', sortable: false }
      ]
    }
  },
  methods: {
    getRowCount () {
      return this.projects.length
    },
    loadProjects () {
      const that = this

      Vue.axios({
        method: 'GET',
        url: '/admin/user/' + this.$route.params.id + '/projects',
        mode: 'no-cors',
        withCredentials: true,
        credentials: 'same-origin'
      }).then(response => {
        if (response.data.status) {
          that.projects = response.data.projects
        } else {
          Vue.swal(
            response.data.message,
            '',
            'warning')
        }
      }).catch(() => {
        Vue.swal(
          'An unexpected error occurred',
          '',
          'warning')
      })
    }
  },
  afterRouteUpdate () {
    this.loadProjects()
  },
  beforeMount () {
    this.loadProjects()
  },
  computed: {
    totalRows () { 
      return this.getRowCount() 
    }
  }
}
</script>